import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GenericDropDownV3, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_Score } from './ModuleFE_Score.js';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { ModuleFE_Variable } from '../variable/ModuleFE_Variable.js';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { ICONS } from '@app/styles';
const getName = (item) => {
    const variable = ModuleFE_Variable.cache.unique(item.variableId);
    if (!variable)
        throw new MUSTNeverHappenException(`Could not find variable for id ${item.variableId}`);
    return variable.name;
};
const Props_DropDown = {
    module: ModuleFE_Score,
    modules: [ModuleFE_Score],
    mapper: item => [getName(item)],
    placeholder: 'Choose a Score',
    renderer: item => _jsx(_Fragment, { children: getName(item) }),
};
export const DropDown_Score = GenericDropDownV3.prepare(Props_DropDown);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_Score,
    itemRenderer: (item, onDelete) => {
        return !item ? _jsx(_Fragment, { children: "Not Found" }) : _jsxs(_Fragment, { children: [_jsx(ICONS.x.component, { onClick: onDelete }), getName(item)] });
    },
    uiSelector: DropDown_Score.selectable,
});
export const MultiSelect_Score = TS_MultiSelect_V2.prepare(Props_MultiSelect);
//# sourceMappingURL=ui-components.js.map